export default {
  score: 0
}



/** WEBPACK FOOTER **
 ** ./src/components/store.js
 **/